import * as React from "react";
import { Component } from "react";
import { stylesheet } from "typestyle";
import { IconNames, MaterialIcon } from "./icon.js";
import { classNames } from "./utils.js";
export class Slideshow extends Component {
    constructor(props) {
        super(props);
        this.interval = NaN;
        this.handleInterval = () => {
            if (!this.state.paused) {
                this.handleNext();
            }
        };
        this.handleBack = () => this.goToSlide(this.state.active - 1);
        this.handleNext = () => this.goToSlide(this.state.active + 1);
        this.handlePause = () => this.setState({ paused: true });
        this.handlePlay = () => this.setState({ paused: false });
        this.state = {
            active: 0,
            paused: false
        };
    }
    componentDidMount() {
        this.interval = window.setInterval(this.handleInterval, this.props.duration || 10000);
    }
    componentWillUnmount() {
        window.clearInterval(this.interval);
    }
    goToSlide(index) {
        if (index < 0) {
            index = 0;
        }
        this.setState({ active: index % this.childrenAsArray.length });
    }
    get childrenAsArray() {
        const { children } = this.props;
        if (!children) {
            return [];
        }
        else if (Array.isArray(children)) {
            return children;
        }
        else {
            return [children];
        }
    }
    render() {
        const { active, paused } = this.state;
        return (React.createElement("div", { className: styles.slideshow },
            this.childrenAsArray.map((child, index) => (React.createElement("div", { key: index, className: classNames(styles.slide, active == index && "activeSlide") }, child))),
            React.createElement("div", { className: styles.bar },
                React.createElement("div", { className: styles.controls },
                    React.createElement("div", { className: styles.playbackControlButton, onClick: this.handleBack },
                        React.createElement(MaterialIcon, { icon: IconNames.skip_previous })),
                    React.createElement("div", { className: styles.playbackControlButton, onClick: paused ? this.handlePlay : this.handlePause },
                        React.createElement(MaterialIcon, { icon: paused ? IconNames.play_arrow : IconNames.pause })),
                    React.createElement("div", { className: styles.playbackControlButton, onClick: this.handleNext },
                        React.createElement(MaterialIcon, { icon: IconNames.skip_next }))),
                React.createElement("div", { className: styles.indicator }, this.childrenAsArray.map((child, index) => (React.createElement("div", { key: index, className: classNames(styles.indicatorItem, active == index && styles.activeIndicatorItem) })))))));
    }
}
const styles = stylesheet({
    slideshow: {
        position: "relative",
        height: "100%"
    },
    slide: {
        opacity: 0,
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        transition: "opacity 0.5s",
        $nest: {
            "&.activeSlide": {
                opacity: 1
            }
        }
    },
    bar: {
        position: "absolute",
        bottom: 0,
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        opacity: 0.5
    },
    controls: {
        display: "flex",
        flexFlow: "row nowrap",
    },
    playbackControlButton: {
        fontSize: "2em",
        lineHeight: 1,
        width: "2rem",
        height: "2rem",
        margin: "0 0.5rem"
    },
    indicator: {
        display: "flex",
        flexFlow: "row nowrap"
    },
    indicatorItem: {
        width: "1em",
        height: "1em",
        borderRadius: "0.5em",
        backgroundColor: "var(--color-foreground)",
        margin: "0.5em"
    },
    activeIndicatorItem: {
        backgroundColor: "var(--color-primary) !important"
    }
});
//# sourceMappingURL=slideshow.js.map